import { cloneDeep } from 'lodash';
import api from 'src/api';

// в константы выносим только названия мутаций,
// которые переиспользуем/планируем переиспользовать
export const SYNC = 'SYNC';

const data = {
  settings: [],
};

const actions = {
  fetchSettings({ commit }, { kind }) {
    return api.getSettings(kind).then((res) => {
      commit(SYNC, res);
    });
  },
  updateSettings({ commit }, { settings }) {
    return api.updateSettings(settings).then((res) => {
      commit(SYNC, res);
    })
      .catch((error) => {
        throw error;
      });
  },
};

const mutations = {
  SYNC(state, response) {
    state.settings = cloneDeep(response);
  },
};

const store = {
  namespaced: true,
  state: data,
  actions,
  mutations,
};

export default store;
